import { usePage } from "PFApp/use_page";
import api from "PFCore/api";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const useEditCollaboratorsConfigs = (initPage, { id }) => {
  const { t } = useTranslation();
  const { page, setPage, mergePage, resetPage } = usePage(
    id ? `collaborators_config/${id}/edit` : "collaborators_config/new",
    initPage
  );

  const fetchCollaboratorsConfigs = ({ id }) =>
    api({
      url: `/admin/participation_rules${id ? `/${id}` : ""}`
    }).then(
      (response) =>
        mergePage({
          loaded: true,
          collaboratorConfig: response
        }),
      () =>
        mergePage({
          loaded: true,
          errors: [t("thereWasAnError")]
        })
    );

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    fetchCollaboratorsConfigs({ id });
  }, []);

  return { ...page, fetchCollaboratorsConfigs };
};
